import React from 'react';

const GenomicsPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-6">
      <div className="w-28 h-28 mb-8 bg-gradient-to-br from-violet-100 to-indigo-50 dark:from-violet-900/20 dark:to-indigo-900/20 rounded-full flex items-center justify-center">
        <span className="text-5xl" role="img" aria-label="DNA">&#x1F9EC;</span>
      </div>
      <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-3">Genomics</h1>
      <p className="text-gray-500 dark:text-gray-400 text-center max-w-md text-lg">
        Coming soon — FASTQ processing, sequence alignment, and variant analysis
      </p>
      <div className="mt-8 px-5 py-3 bg-violet-50 dark:bg-violet-900/20 border border-violet-200 dark:border-violet-800 rounded-xl text-sm text-violet-600 dark:text-violet-400">
        This module is under active development
      </div>
    </div>
  );
};

export default GenomicsPage;
